'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { isOpenFinanceCallbackPath } from '@/lib/open-finance/consent-callback-handoff';
import { captureFirstTouchUTM } from '@/lib/utm-tracker';

interface UTMTrackerProviderProps {
  children: React.ReactNode;
}

/**
 * Provider global que captura UTMs da URL ao montar
 * Deve ser adicionado no layout root (app/layout.tsx)
 */
export function UTMTrackerProvider({ children }: UTMTrackerProviderProps) {
  const pathname = usePathname();
  const skipTracking = isOpenFinanceCallbackPath(pathname);

  useEffect(() => {
    if (skipTracking) return;
    captureFirstTouchUTM();
  }, [skipTracking]);

  return <>{children}</>;
}
